import * as React from 'react';
import { memo } from 'react';
import { Provider } from 'react-redux';

import { useGraphQLClient } from '../../../graphql-client';
import { createStore } from '../store';
import Checkin from './Checkin/Checkin';
import Analytics from '../../../Engine/components/Analytics';
import { GuardedApolloProvider } from '../../../GuardedApolloProvider';
import { ModeContext } from '../../../context';
import { Mode } from '../../../types';
import IsDemo from '../../../Engine/components/IsDemo';
import AccessDeniedError from '../../../Engine/components/AccessDeniedError';
import { BootstrapGate } from '@shared/ui';
import PixelPageViewWatcher from '../../../Engine/components/PixelPageViewWatcher';
import { ErrorManager } from '@entities/error';

export const Module = memo(() => {
	const client = useGraphQLClient();
	const store = createStore();

	return (
		<BootstrapGate>
			<GuardedApolloProvider client={client}>
				<Provider store={store}>
					<ModeContext.Provider value={Mode.Checkin}>
						<Analytics />
						<IsDemo />
						<AccessDeniedError />
						<PixelPageViewWatcher />
						<Checkin />
						<ErrorManager />
					</ModeContext.Provider>
				</Provider>
			</GuardedApolloProvider>
		</BootstrapGate>
	);
});

export default Module;
